/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Header_v2 from './header_v2';
import { useState } from 'react';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { notificationController } from '@app/controllers/notificationController';
import { doConsultarDatosAntropometricos } from '@app/api/slices/pacienteSlice';
import { getIdPaciente, getUsuario, isLoggin, isPaciente } from '@app/utils/localStorage.service';
import { Loading } from '@app/components/common/Loading';
import { Container } from 'react-bootstrap';
import { Row } from 'antd';
import { ActividadFisicaModel } from '@app/models/ActividadFisicaDatosModel';
import { DatosAntropometricosModel } from '@app/models/DatosAntropometricosModel';

const ConsultaDatosAntropometricos: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoadingPage, setLoadingPage] = useState(true);
  const { t } = useTranslation();
  const [paciente, setPaciente] = useState(getUsuario());
  const datosAnt: DatosAntropometricosModel[] = [];
  const [datosAntropometricos, setDatosAntropometricos] = useState(datosAnt);

  useEffect(() => {
    if (isLoggin() != null) {
      if (isPaciente()) {
        dispatch(doConsultarDatosAntropometricos(getIdPaciente()))
          .unwrap()
          .then((res) => {
            setLoadingPage(false);
            setDatosAntropometricos(res.data);
          })
          .catch((err) => {
            notificationController.error({ message: err.message });
          });
      } else {
        notificationController.error({ message: 'Solo los pacientes tienen acceso' });
        navigate('/');
      }
    } else {
      notificationController.error({ message: 'Es necesario iniciar sesion.' });
      navigate('/');
    }
  }, []);

  if (isLoadingPage) {
    return <Loading />;
  }

  return (
    <div>
      <Header_v2 />
      <Container>
        <div className="green-bar">
          <Row>
            <h2 className="section-title">Consulta datos antropometricos</h2>
          </Row>
        </div>
        <br />
        <h4>
          Paciente: {paciente.paciente.nombre} {paciente.paciente.apellido_paterno} {paciente.paciente.apellido_materno}
        </h4>
        <div>
          <table className="table">
            <thead className="text-center">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Peso</th>
                <th scope="col">Estatura</th>
                <th scope="col">IMC</th>
                <th scope="col">Cadera</th>
                <th scope="col">ICC</th>
                <th scope="col">Grasa</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {datosAntropometricos.map((item) => (
                <tr key={item.id_medicion}>
                  <td>{item.id_medicion}</td>
                  <td>{item.peso}</td>
                  <td>{item.estatura}</td>
                  <td>{item.imc}</td>
                  <td>{item.cadera}</td>
                  <td>{item.icc}</td>
                  <td>{item.grasa}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="form-buttons">
          <button type="button" onClick={() => navigate('/analisis_datos_v2')}>
            Volver
          </button>
        </div>
      </Container>
    </div>
  );
};

export default ConsultaDatosAntropometricos;
